/**
 * @generated SignedSource<<1455469095d2fcc0fc52e6d5714a1c13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryPickerRepositoryLight$data = {
  readonly databaseId: number | null | undefined;
  readonly id: string;
  readonly isInOrganization: boolean;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly nameWithOwner: string;
  readonly owner: {
    readonly avatarUrl: string;
    readonly databaseId: number | null | undefined;
    readonly login: string;
  };
  readonly shortDescriptionHTML: string;
  readonly " $fragmentType": "RepositoryPickerRepositoryLight";
};
export type RepositoryPickerRepositoryLight$key = {
  readonly " $data"?: RepositoryPickerRepositoryLight$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryPickerRepositoryLight">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "RepositoryPickerRepositoryLight"
};

(node as any).hash = "c3603a4ea1983f86e0cfa857c837defe";

export default node;
